import React from 'react';
import CSSModules from 'react-css-modules';
import * as PropTypes from 'prop-types';

import styles from '../styles.styl';

function VideoVisitAWView({ formatMessage }) {
  return (
    <div styleName="row">
      <span className={styles.videoVisitAW}>
        {formatMessage({ id: 'appointment.list.card.videoVisitAW' })}
      </span>
    </div>
  );
}

VideoVisitAWView.propTypes = {
  formatMessage: PropTypes.func,
};

export default CSSModules(VideoVisitAWView, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentCard/Views/VideoVisitAWView.jsx